import React, { useState, useEffect, useMemo } from 'react';
import { Check2, Clipboard } from 'react-bootstrap-icons';
import { showGlassToast } from './GlassToast';

const Codee = ({ children }) => {
  const [isCopied, setIsCopied] = useState(false);
  const copyText = useMemo(() => (
    React.Children.toArray(children)
      .map((child) => {
        if (typeof child === 'string' || typeof child === 'number') return String(child);
        if (child == null) return '';
        return String(child);
      })
      .join('')
      .trim()
  ), [children]);

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '0';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      return document.execCommand('copy');
    } catch (err) {
      console.error('Ошибка при копировании: ', err);
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  };

  const copyToClipboard = async () => {
    if (!copyText) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(copyText);
      } else if (!fallbackCopyToClipboard(copyText)) {
        return;
      }
      setIsCopied(true);
      showGlassToast('Текст скопирован', { duration: 1500 });
    } catch (err) {
      if (fallbackCopyToClipboard(copyText)) {
        setIsCopied(true);
        showGlassToast('Текст скопирован', { duration: 1500 });
      } else {
        console.error('Ошибка при копировании: ', err);
      }
    }
  };

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    void copyToClipboard();
  };

  return (
    <>
      <button
        type="button"
        className={`codee-chip ${isCopied ? 'codee-chip--copied' : ''}`}
        onClick={handleClick}
        onPointerDown={(event) => event.stopPropagation()}
        onTouchStart={(event) => event.stopPropagation()}
        title={isCopied ? 'Скопировано' : 'Скопировать'}
        aria-label={isCopied ? 'Скопировано' : `Скопировать ${copyText}`}
      >
        <code className="codee-chip__text">{children}</code>
        <span className="codee-chip__icon" aria-hidden="true">
          {isCopied ? <Check2 size={12} /> : <Clipboard size={12} />}
        </span>
      </button>
    </>
  );
};

export default Codee;
